"use strict";
var proxyEnabled = typeof Proxy !== "undefined";
function enableProxy(enabled) {
    proxyEnabled = enabled;
}
exports.enableProxy = enableProxy;
var prototype = {};
function makeBoxedValue(obj, key) {
    // MobX will leave it alone if it has a prototype    
    var value = Object.create(prototype);
    value.get = function () { return obj[key]; };
    value.set = function (val) { return obj[key] = val; };
    return value;
}
exports.makeBoxedValue = makeBoxedValue;
function boxer(propertyBoxer) {
    var handler = {
        get: function (target, key) {
            return propertyBoxer(target, key);
        }
    };
    return function (obj) {
        if (proxyEnabled) {
            return new Proxy(obj, handler);
        }
        var fallbackProxy = {};
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var key = _a[_i];
            fallbackProxy[key] = propertyBoxer(obj, key);
        }
        return fallbackProxy;
    };
}
exports.boxer = boxer;
exports.box = boxer(makeBoxedValue);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/boxm/built/index.js
// module id = 193
// module chunks = 0